// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__3O4SS","title":"ClientCherryInfo_title__1unBF","itemText":"ClientCherryInfo_itemText__3fhZr"};